export interface PaymentFormState {
  paymentType: 'CASH' | 'INSTALLMENTS' | '';
  dueDay: string;
  installmentCount: string;
  hasEntrance: boolean;
  entrancePercent: string;
}

export interface CartStepValidation {
  isCartValid: boolean;
  isPaymentValid: boolean;
  isStepValid: boolean;
  message: string | null;
}

export function validateCartStep(
  cartItemCount: number,
  payment: PaymentFormState,
  allowedPaymentMethods?: string[],
  minEntradaPercent?: number,
): CartStepValidation {
  const isCartValid = cartItemCount > 0;

  if (!isCartValid) {
    return {
      isCartValid: false,
      isPaymentValid: false,
      isStepValid: false,
      message: 'Adicione pelo menos um item ao carrinho',
    };
  }

  if (!payment.paymentType) {
    return {
      isCartValid: true,
      isPaymentValid: false,
      isStepValid: false,
      message: 'Selecione o tipo de pagamento',
    };
  }

  if (allowedPaymentMethods?.length && !allowedPaymentMethods.includes(payment.paymentType)) {
    return {
      isCartValid: true,
      isPaymentValid: false,
      isStepValid: false,
      message: 'Tipo de pagamento não permitido pela análise de crédito',
    };
  }

  if (payment.paymentType === 'INSTALLMENTS') {
    if (!payment.installmentCount) {
      return {
        isCartValid: true,
        isPaymentValid: false,
        isStepValid: false,
        message: 'Selecione o numero de parcelas',
      };
    }
    if (!payment.dueDay) {
      return {
        isCartValid: true,
        isPaymentValid: false,
        isStepValid: false,
        message: 'Selecione o dia de vencimento',
      };
    }
    if (payment.hasEntrance && (!payment.entrancePercent || Number(payment.entrancePercent) <= 0)) {
      return {
        isCartValid: true,
        isPaymentValid: false,
        isStepValid: false,
        message: 'Informe a porcentagem de entrada',
      };
    }
    if (payment.hasEntrance && minEntradaPercent && minEntradaPercent > 0) {
      const pct = Number(payment.entrancePercent) || 0;
      if (pct > 0 && pct < minEntradaPercent) {
        return {
          isCartValid: true,
          isPaymentValid: false,
          isStepValid: false,
          message: `Entrada mínima permitida: ${minEntradaPercent}%`,
        };
      }
    }
  }

  return {
    isCartValid: true,
    isPaymentValid: true,
    isStepValid: true,
    message: null,
  };
}
